import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkSpacing } from 'uitk-react-spacing';

export const MainRegion: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.masterPage.main">
      <section data-stid="search-results__main" itemScope={true} itemType={'https://schema.org/Hotel'}>
        <UitkSpacing margin={{ small: { inline: 'three' }, medium: { inline: 'unset' } }}>
          <div>
            <ExperienceTemplateRenderer templateComponents={children} />
          </div>
        </UitkSpacing>
      </section>
    </ErrorBoundary>
  );
};
